import React, { useContext, useEffect, useState } from "react";
import classes from "./Navbar.module.css";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa";
import ReactCountryFlag from "react-country-flag";
import { IoGitCompareOutline } from "react-icons/io5";
import InfoIcon from "@mui/icons-material/Info";
import { Button } from "antd";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  FormControl,
  Select,
  Modal,
} from "@mui/material";
import { IoBagOutline } from "react-icons/io5";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchBox from "./Search box/SearchBox";
import LanCurrSelect from "./Language and Currency/LanCurrSelect";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "@hooks/useNavigate";
import { Link as LinkSS } from "react-scroll";
import * as Scroll from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import {
  removeUser,
  changeCurrency,
  changeLanguage,
  addSelectedCategory,
  resetSearchData,
  editSearchData,
} from "../../redux/productSlice";
import axios from "axios";
import AuthContext from "../authContext";
import ColoredLogo from "../../../assets/ColoredLogo.png";
import CurrencyLangIcon from "../../../assets/CurrencyLangIcon.png";
import allcat from "../../../assets/icons/all-cat.svg";
import { buildFilterUrl } from "../../../utils/filterUrl";

const Navbar = ({ toggle, carttoggle }) => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language,
  );
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency,
  );
  const productData = useSelector((state) => state.products.productData);
  const favoriteData = useSelector((state) => state.products.favorites);
  const compareData = useSelector((state) => state.products.compare);
  const userInfo = useSelector((state) => state.products.userInfo);

  const [isSearchBar, setIsSearchBar] = useState(false);
  const settings = ["Profile", "Logout"];
  const dispatch = useDispatch();
  const [isScrolled, setIsScrolled] = useState(false);
  const [popover, setPopover] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [openmodal, setOpenmodal] = useState(false);
  const [openLanguage, setOpenLanguage] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);
  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const [hoveredSubCategoryId, setHoveredSubCategoryId] = useState(null);
  const [subCategories, setSubCategories] = useState([]);
  const [categoryDropdownPos, setCategoryDropdownPos] = useState({
    top: 0,
    left: 0,
    maxHeight: 420,
  });
  const [childDropdownPos, setChildDropdownPos] = useState({
    top: 0,
    left: 0,
    right: "auto",
    maxHeight: 420,
  });
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const location = path.split("/")[1];
  const scroller = Scroll.scroller;

  // A click on a category/subcategory link navigates without the mouse ever
  // leaving the trigger, so onMouseLeave never fires and the hover dropdown
  // stays open — overlapping the new page's content until the cursor
  // happens to move. Close it as soon as the route actually changes.
  useEffect(() => {
    setHoveredCategoryId(null);
    setHoveredSubCategoryId(null);
  }, [path]);

  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_TESTING_API}/article-famille?ecom_type=hanoot`,
        );
        setSubCategories(response.data);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };
    fetchSubCategories();
  }, []);

  // Keeps a hover dropdown fully on-screen: clamps its top so it never starts
  // low enough to run off the bottom of the viewport, and returns a matching
  // maxHeight so a long list scrolls internally instead of becoming unreachable.
  const clampDropdownVertical = (desiredTop, minVisible = 150, margin = 12) => {
    const maxTop = Math.max(margin, window.innerHeight - margin - minVisible);
    const top = Math.max(margin, Math.min(desiredTop, maxTop));
    const maxHeight = window.innerHeight - top - margin;
    return { top, maxHeight };
  };

  // Centers a dropdown under its trigger without relying on a CSS transform
  // (a transform on the dropdown would become a containing block for any
  // position:fixed descendant, like the child flyout, breaking its own
  // viewport-relative positioning).
  const clampDropdownHorizontalCentered = (centerX, estimatedWidth = 300, margin = 12) => {
    const desiredLeft = centerX - estimatedWidth / 2;
    return Math.max(margin, Math.min(desiredLeft, window.innerWidth - estimatedWidth - margin));
  };

  const getSubcategories = (parentId) => {
    return (
      subCategories
        ?.filter((item) => item.b_usr_parentcategorie_id === parentId)
        ?.sort((a, b) => a.type_nom.localeCompare(b.type_nom)) || []
    );
  };

  const getChildSubcategories = (subCategoryId) => {
    return (
      authCtx?.subsubCategories
        ?.filter(
          (item) =>
            Number(item.b_usr_articlecategorie_id) === Number(subCategoryId),
        )
        ?.sort((a, b) => (a.nom || "").localeCompare(b.nom || "")) || []
    );
  };

  // Side effects only (localStorage sync + redux) — actual navigation now
  // happens via the <Link to={...}> the caller wraps this handler with, so
  // the href is real and crawlable instead of only existing after a click.
  const handleAllCategoryClick = () => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
    dispatch(addSelectedCategory(null));
  };

  const slugify = (text) =>
    (text || "").toString().trim().replace(/\s+/g, "-").toLowerCase();

  const getParentCategoryHref = (parentId, parentName) =>
    buildFilterUrl(`/cp/${slugify(parentName)}/${parentId}`, { parentCategories: [parentId] });

  const handleParentCategoryClick = (parentId) => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
    dispatch(addSelectedCategory(String(parentId)));
    localStorage.setItem("parentCategories", JSON.stringify([parentId]));
  };

  // The handler below always wipes "subCategories" then sets only this id,
  // so a click here ever only ends up filtering on this one subcategory.
  const getSubCategoryHref = (id, name, parentName, parentId) =>
    buildFilterUrl(`/cp/${slugify(parentName)}/${slugify(name)}/${id}`, {
      parentCategories: [parentId],
      subCategories: [id],
    });

  const handleSubCategoryClick = (id, parentId) => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
    dispatch(addSelectedCategory(String(parentId)));
    localStorage.setItem("parentCategories", JSON.stringify([parentId]));
    localStorage.setItem("subCategories", JSON.stringify([id]));
  };

  const getChildSubCategoryHref = (id, childName, subCategoryName, parentName, parentId) =>
    buildFilterUrl(`/cp/${slugify(parentName)}/${slugify(subCategoryName)}/${slugify(childName)}/${id}`, {
      parentCategories: parentId ? [parentId] : undefined,
      subSubCategories: [id],
    });

  const handleChildSubCategoryClick = (id, parentId) => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());

    if (parentId)
      localStorage.setItem("parentCategories", JSON.stringify([parentId]));
    localStorage.setItem("subSubCategories", JSON.stringify([id]));
  };

  const handleBestSellersClick = () => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
  };

  const handleNouveautesClick = () => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
    dispatch(editSearchData({ newarrival: true }));
  };

  const NavigateAndScroll = (props) => {
    if (path === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      setTimeout(() => {
        scroller.scrollTo(props, {
          duration: 500,
          delay: 0,
          smooth: true,
          offset: 50,
        });
      }, 400);
    }
  };

  const logout = async () => {
    try {
      // Get the token from local storage
      const token = sessionStorage.getItem("token");

      // If token is not available, there's no need to logout
      if (!token) {
        localStorage.removeItem("token");

        dispatch(removeUser());
        navigate(`/login`);
        return;
      }

      // Set up headers with the token
      const headers = {
        Accept: `application/json`,
        Authorization: `Bearer ${token}`,
      };

      // Send a POST request to the logout endpoint
      await axios.get(`${import.meta.env.VITE_TESTING_API}/logout`, {
        headers,
      });

      // Add any additional logic you may need, such as redirecting the user to the login page or updating the application state
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle any errors that occur during logout
    }
    // Remove the token from local storage after successful logout
    localStorage.removeItem("token");

    dispatch(removeUser());
    navigate(`/login`);
  };

  const handleLogout = async () => {
    try {
      await logout();
      // Perform any additional actions after successful logout
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle logout error
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY > 80;
      if (isTop !== isScrolled) {
        setIsScrolled(isTop);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getToken = () => {
    return sessionStorage.getItem("token");
  };

  const token = getToken();

  const handleCloseModal = () => {
    setOpenmodal(false);
  };

  const handleChangeCurrency = async (event) => {
    const cur = event.target.value;

    if (currency === "eur" && !authCtx.currencyRate) {
      return setOpenmodal(true);
    }

    dispatch(changeCurrency({ currency: cur }));

    try {
      await axios.put(
        `${import.meta.env.VITE_TESTING_API}/users/${userInfo.id}`,
        { currency: cur },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      console.error("Error updating currency:", error);
    }
  };

  const handleChangeLanguage = async (event) => {
    const lan = event.target.value;
    dispatch(changeLanguage({ Language: lan }));
    try {
      await axios.put(
        `${import.meta.env.VITE_TESTING_API}/users/${userInfo.id}`,
        { language: lan },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      console.error("Error updating language:", error);
    }
  };

  const defaultStyle = {
    padding: ".5em 1em",
    color: "#111",
    textAlign: "center",
    border: "1px solid #F6F6F6",
    width: "fit-content",
    height: "fit-content",
    borderRadius: "30px",
    whiteSpace: "nowrap",
    fontSize: "calc(0.7rem + 0.3vw)",
    backgroundColor: "#F6F6F6",
    cursor: "pointer",
    margin: "auto 0",
    transition: "background-color 0.3s, color 0.3s",
    position: "relative",
    fontWeight: "500",
  };

  const hoverStyle = {
    backgroundColor: "#fff",
    color: "var(--primary-color)",
    border: "1px solid var(--primary-color)",
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "fit-content",
    bgcolor: "background.paper",
    border: "2px solid #ACACAC",
    borderRadius: "1em",
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    p: 4,
  };

  const categoriesNavContent = (
    <div className={classes.categoriesNav}>
      <Link to="/products" className={classes.categoryLabel} onClick={handleAllCategoryClick}>
        {language === "eng" ? "All Products" : "Tous Nos Produits"}
      </Link>

      {authCtx?.articleFamilleParents?.map((parent) => (
        <div
          key={parent.id}
          className={classes.categoryIconWrapper}
          onMouseEnter={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            const { top, maxHeight } = clampDropdownVertical(rect.bottom);
            const left = clampDropdownHorizontalCentered(rect.left + rect.width / 2);
            setCategoryDropdownPos({
              top,
              left,
              maxHeight,
            });
            setHoveredCategoryId(parent.id);
            setHoveredSubCategoryId(null);
          }}
          onMouseLeave={() => {
            setHoveredCategoryId(null);
            setHoveredSubCategoryId(null);
          }}
        >
          <Link
            to={getParentCategoryHref(parent.id, parent.nom)}
            className={classes.categoryLabel}
            onClick={() => handleParentCategoryClick(parent.id)}
          >
            {parent.nom}
          </Link>

          {hoveredCategoryId === parent.id &&
            getSubcategories(parent.id).length > 0 && (
              <div
                className={classes.categoryDropdown}
                style={{
                  top: categoryDropdownPos.top,
                  left: categoryDropdownPos.left,
                  maxHeight: categoryDropdownPos.maxHeight,
                }}
                onMouseEnter={() => {
                  setHoveredCategoryId(parent.id);
                }}
                onMouseLeave={() => {
                  setHoveredCategoryId(null);
                  setHoveredSubCategoryId(null);
                }}
              >
                <div className={classes.dropdownHeader}>{parent.nom}</div>
                <div className={classes.dropdownContent}>
                  {getSubcategories(parent.id).map((sub) => (
                    <div
                      key={sub.id}
                      className={classes.dropdownItemWrapper}
                      onMouseEnter={(e) => {
                        const rect = e.currentTarget.getBoundingClientRect();
                        const { top, maxHeight } = clampDropdownVertical(rect.top);
                        const estimatedWidth = 300;
                        const gap = 6;
                        const openLeft =
                          window.innerWidth - rect.right < estimatedWidth &&
                          rect.left > estimatedWidth;
                        setChildDropdownPos({
                          top,
                          maxHeight,
                          left: openLeft ? "auto" : rect.right + gap,
                          right: openLeft ? window.innerWidth - rect.left + gap : "auto",
                        });
                        setHoveredSubCategoryId(sub.id);
                      }}
                      onMouseLeave={() => setHoveredSubCategoryId(null)}
                    >
                      <Link
                        to={getSubCategoryHref(sub.id, sub.type_nom || sub.nom, parent.nom, parent.id)}
                        className={classes.dropdownItem}
                        onClick={() => handleSubCategoryClick(sub.id, parent.id)}
                      >
                        <img loading="lazy" src={sub.dark_image || allcat} srcSet={sub.dark_image || allcat} alt={sub.nom} />
                        <span>{sub.type_nom || sub.nom}</span>
                        {getChildSubcategories(sub.id).length > 0 && (
                          <span className={classes.childIndicator}>›</span>
                        )}
                      </Link>

                      {hoveredSubCategoryId === sub.id &&
                        getChildSubcategories(sub.id).length > 0 && (
                          <div
                            className={classes.childDropdown}
                            style={{
                              top: childDropdownPos.top,
                              left: childDropdownPos.left,
                              right: childDropdownPos.right,
                              maxHeight: childDropdownPos.maxHeight,
                            }}
                            onMouseEnter={() => setHoveredSubCategoryId(sub.id)}
                            onMouseLeave={() => setHoveredSubCategoryId(null)}
                          >
                            {getChildSubcategories(sub.id).map((child) => (
                              <Link
                                key={child.id}
                                to={getChildSubCategoryHref(
                                  child.id,
                                  child.nom,
                                  sub.type_nom || sub.nom,
                                  parent.nom,
                                  parent.id,
                                )}
                                className={classes.childDropdownItem}
                                onClick={() => handleChildSubCategoryClick(child.id, parent.id)}
                              >
                                <img loading="lazy"
                                  src={child.dark_image || allcat} srcSet={child.dark_image || allcat}
                                  alt={child.nom}
                                />
                                <span>{child.nom}</span>
                              </Link>
                            ))}
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              </div>
            )}
        </div>
      ))}

      <Link to="/bestsellers" className={classes.categoryLabel} onClick={handleBestSellersClick}>
        {language === "eng" ? "Best Sellers" : "Meilleures Ventes"}
      </Link>

      <Link to="/nouveautes" className={classes.categoryLabel} onClick={handleNouveautesClick}>
        {language === "eng" ? "New Arrivals" : "Nouveautés"}
      </Link>

      <Link to="/brands" className={classes.categoryLabel}>
        {language === "eng" ? "Brands" : "Nos Marques"}
      </Link>
    </div>
  );

  return (
    <>
      {isScrolled && (
        <div
          style={{ position: "relative", height: "5em", width: "100%" }}
        ></div>
      )}
      <div className={`${isScrolled ? classes.fixednav_con : classes.headnav}`}>
        {!isScrolled && (
          <div className={classes.topdiv}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                columnGap: "1em",
              }}
            >
              <p
                style={{
                  margin: "auto 0",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {language === "eng"
                  ? authCtx.companySettings?.announcement_bar_text_en
                  : authCtx.companySettings?.announcement_bar_text_fr}{" "}
                <br className={classes.mobileDisplay} />
                <a
                  href={authCtx.companySettings?.announcement_bar_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: "pointer",
                    padding: ".3em 1em",
                    border: "1px solid #fff",
                    borderRadius: "20em",
                    margin: "0 1em",
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  {language === "eng"
                    ? authCtx.companySettings?.announcement_bar_link_en
                    : authCtx.companySettings?.announcement_bar_link_fr}
                </a>
              </p>
            </div>
          </div>
        )}
        <div className={classes.header}>
          {
            <LanCurrSelect
              toggle={toggle}
              isSearchBar={isSearchBar}
              setIsSearchBar={setIsSearchBar}
            />
          }
          <div className={classes.logocontainer}>
            <Link to="/" onClick={NavigateAndScroll}>
              <img
                src={ColoredLogo} srcSet={ColoredLogo}
                style={{ cursor: "pointer" }}
                alt="logodark"
              />
            </Link>
          </div>
          <div className={classes.headercontent}>
            <div className={classes.bottomdiv}>
              <div className={classes.options}>
                <button
                  style={{ ...defaultStyle, ...(isHovered ? hoverStyle : {}) }}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  variant="contained"
                >
                  <img loading="lazy"
                    src={CurrencyLangIcon} srcSet={CurrencyLangIcon}
                    alt=""
                    style={{ width: "1.4em", margin: "0 .5em -.45em 0" }}
                  />
                  <span
                    onClick={() => setOpenLanguage(true)}
                    style={{ position: "relative", cursor: "pointer" }}
                  >
                    {language === "eng" ? (
                      <ReactCountryFlag
                        countryCode="GB"
                        svg
                        style={{ marginRight: "0" }}
                      />
                    ) : (
                      <ReactCountryFlag
                        countryCode="FR"
                        svg
                        style={{ marginRight: "0" }}
                      />
                    )}
                  </span>
                  <FormControl
                    style={{
                      display: openLanguage ? "inline-block" : "none",
                      position: "absolute",
                      top: "-1em",
                      left: "0",
                      opacity: 0,
                    }}
                  >
                    <Select
                      open={openLanguage}
                      onClose={() => setOpenLanguage(false)}
                      onOpen={() => setOpenLanguage(true)}
                      value={language}
                      onChange={handleChangeLanguage}
                    >
                      <MenuItem value="eng">
                        <ReactCountryFlag
                          countryCode="GB"
                          svg
                          style={{ marginRight: "0.5em" }}
                        />
                        English
                      </MenuItem>
                      <MenuItem value="fr">
                        <ReactCountryFlag
                          countryCode="FR"
                          svg
                          style={{ marginRight: "0.5em" }}
                        />
                        Français
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <span
                    style={{
                      color: "var(--secondary-color)",
                      padding: "0 .3em",
                    }}
                  >
                    {" "}
                    |{" "}
                  </span>
                  <span
                    onClick={() => setOpenCurrency(true)}
                    style={{ fontWeight: "700", cursor: "pointer" }}
                  >
                    {currency === "eur" ? "€" : "$"}
                  </span>
                  <FormControl
                    style={{
                      display: openCurrency ? "inline-block" : "none",
                      position: "absolute",
                      top: "-1em",
                      right: "0",
                      opacity: 0,
                    }}
                  >
                    <Select
                      open={openCurrency}
                      onClose={() => setOpenCurrency(false)}
                      onOpen={() => setOpenCurrency(true)}
                      value={currency}
                      onChange={handleChangeCurrency}
                    >
                      <MenuItem value="eur">Euro (€)</MenuItem>
                      <MenuItem value="usd">Dollar ($)</MenuItem>
                    </Select>
                  </FormControl>
                </button>
                <div
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  className={classes.icon}
                >
                  <Tooltip
                    title={
                      language === "eng" ? "Wishlist" : "Liste De Souhaits"
                    }
                  >
                    <IconButton
                      sx={{ p: 0 }}
                      component={Link}
                      to="/wishlist"
                      onClick={(event) => {
                        if (!userInfo?.id) {
                          event.preventDefault();
                          toast.error(
                            language === "eng"
                              ? "Please log in to access your wishlist"
                              : "Veuillez vous connecter pour accéder à votre liste de souhaits",
                            { position: "top-right", autoClose: 2000 }
                          );
                        }
                      }}
                    >
                      <FaRegHeart
                        alt=""
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--secondary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {favoriteData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--primary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {favoriteData?.length}
                    </span>
                  )}
                </div>
                <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                  <Tooltip title={language === "eng" ? "Cart" : "Panier"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                        // if (userInfo) {
                        carttoggle();
                        // } else {
                        //   navigate(`/login`);
                        // }
                      }}
                    >
                      <IoBagOutline
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--secondary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {productData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--primary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {productData?.length}
                    </span>
                  )}
                </div>
                {/* <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={toggle}
                    >
                    <MenuIcon 
                        style={{
                          width: "36px",
                          height: "36px",
                          color: "var(--secondary-color)",
                          margin: "3px 6px",
                        }} />
                        </IconButton>
                </div> */}
                {/* <div
                  style={{ width: "30px", height: "30px", marginTop: "-12px" }}
                >
                  <Box sx={{ flexGrow: 0 }}>
                    <Tooltip
                      title={language === "eng" ? "Profile" : "Mon Compte"}
                    >
                      <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                        {userInfo?.id ? (
                          <Avatar
                            alt={userInfo.first_name}
                            src={`${import.meta.env.VITE_TESTING_API_IMAGE}/img/${userInfo.image}`}
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                            }}
                            className={classes.icon}
                          />
                        ) : (
                          <PersonIcon
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                            }}
                            className={classes.icon}
                          />
                        )}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {categoriesNavContent}
        {/*  */}
        {/* <div className={`${isScrolled ? classes.rightsidenav : classes.none}`}>
          <div className={classes.siderowright}>
            <div
              style={{
                width: "30px",
                height: "30px",
                margin: "8px",
                borderRadius: "50%",
              }}
            >
              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Profile">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    {userInfo?.id ? (
                      <Avatar
                        alt={userInfo.first_name}
                        src={`${import.meta.env.VITE_TESTING_API_IMAGE}/img/${userInfo.image}`}
                        style={{
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                        }}
                        className={classes.icon}
                      />
                    ) : (
                      <PersonIcon
                        style={{
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                          color: "#fff",
                        }}
                      />
                    )}
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {userInfo?.id ? (
                    <div>
                      <MenuItem
                        key={1}
                        onClick={() => {
                          navigate(`/accountprofile`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Profile" : "Mon Compte"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={2}
                        onClick={() => {
                          navigate(`/ordertracking`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng"
                            ? "Orders Tracking"
                            : "Suivi des Commandes"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={3}
                        onClick={() => {
                          navigate(`/refund_return`);
                          handleCloseUserMenu();
                        }}
                      >
                        <Typography textAlign="center">
                          {language === "eng"
                            ? "Orders Returns"
                            : "Retours de Commandes"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={4}
                        onClick={() => (handleCloseUserMenu(), handleLogout())}
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Logout" : "Déconnexion"}{" "}
                        </Typography>
                      </MenuItem>
                    </div>
                  ) : (
                    <div>
                      <MenuItem
                        key={1}
                        onClick={() =>
                          handleCloseUserMenu() & navigate(`/login`)
                        }
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Login" : "Se Connecter"}
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        key={2}
                        onClick={() =>
                          handleCloseUserMenu() & navigate(`/register`)
                        }
                      >
                        <Typography textAlign="center">
                          {language === "eng" ? "Register" : "Créer un compte"}
                        </Typography>
                      </MenuItem>
                    </div>
                  )}
                </Menu>
              </Box>
            </div>
          </div>
          <div className={classes.siderowright}>
            <Tooltip title="Cart">
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  if (userInfo) {
                    carttoggle();
                  } else {
                    navigate(`/login`);
                  }
                }}
              >
                <IoBagOutline
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {productData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {productData?.length}
              </span>
            )}
          </div>
          <div className={classes.siderowright}>
            <Tooltip title="Wishlist">
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  if (userInfo) {
                    navigate(`/wishlist`);
                  } else {
                    navigate(`/login`);
                  }
                }}
              >
                <FaRegHeart
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {favoriteData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {favoriteData?.length}
              </span>
            )}
          </div>
          <div className={classes.siderowright}>
            <Tooltip title="Compare">
              <IconButton
                sx={{ p: 0 }}
                onClick={() => {
                  if (userInfo) {
                    navigate(`/compare`);
                  } else {
                    navigate(`/login`);
                  }
                }}
              >
                <IoGitCompareOutline
                  style={{
                    width: "30px",
                    height: "30px",
                    color: "#fff",
                    margin: "55% auto",
                  }}
                />
              </IconButton>
            </Tooltip>
            {compareData?.length !== 0 && (
              <span
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  position: "absolute",
                  marginLeft: "-12px",
                  marginTop: "5px",
                  borderRadius: "50%",
                  background: "var(--accent-color)",
                  textAlign: "center",
                  color: "var(--secondary-color)",
                }}
              >
                {compareData?.length}
              </span>
            )}
          </div>
        </div>
        <div className={`${isScrolled ? classes.leftsidenav : classes.none}`}>
          <div className={classes.siderow}>
            <a href={authCtx.companySettings.facebook} target="_blank">
              <FaFacebookF
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>
          <div className={classes.siderow}>
            <a href={authCtx.companySettings.twitter} target="_blank">
              {" "}
              <FaXTwitter
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>
          <div className={classes.siderow}>
            <a href={authCtx.companySettings.linkedin} target="_blank">
              <FaLinkedinIn
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>
          <div className={classes.siderow}>
            <a href={authCtx.companySettings.insta} target="_blank">
              {" "}
              <FaInstagram
                style={{
                  color: "#fff",
                  width: "30px",
                  height: "30px",
                  margin: "22% auto",
                }}
              />
            </a>
          </div>
        </div> */}
      </div>
      <div className={classes.mobilenav}>
        <div
          style={{
            margin: "auto 0",
            width: "96%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: ".7em 2%",
          }}
        >
          {/* Hamburger — top-left */}
          <div className={classes.siderowrightmobile}>
            <Tooltip title="menu">
              <IconButton sx={{ p: 0 }} onClick={toggle}>
                <MenuIcon
                  style={{
                    width: "26px",
                    height: "26px",
                    color: "var(--secondary-color)",
                    margin: "0",
                  }}
                />
              </IconButton>
            </Tooltip>
          </div>

          {/* Logo — centered (absolute so uneven side widths can't shift it) */}
          <Link
            to="/"
            className={classes.logomobile}
            onClick={NavigateAndScroll}
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
            }}
          >
            <img
              style={{ objectFit: "contain", margin: "0em auto" }}
              src={ColoredLogo} srcSet={ColoredLogo}
              alt="logodark"
            />
          </Link>

          {/* Cart + wishlist — right */}
          <div className={classes.rightsidenavMobile}>
            <div className={classes.siderowrightmobile}>
              <Tooltip title="Cart">
                <IconButton
                  sx={{ p: 0 }}
                  component={Link}
                  to={"/cart"}
                >
                  <IoBagOutline
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--secondary-color)",
                      margin: "0",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {productData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {productData?.length}
                </span>
              )}
            </div>
            <div className={classes.siderowrightmobile}>
              <Tooltip title="Wishlist">
                <IconButton
                  sx={{ p: 0 }}
                  component={Link}
                  to="/wishlist"
                  onClick={(event) => {
                    if (!userInfo?.id) {
                      event.preventDefault();
                      toast.error(
                        language === "eng"
                          ? "Please log in to access your wishlist"
                          : "Veuillez vous connecter pour accéder à votre liste de souhaits",
                        { position: "top-right", autoClose: 2000 }
                      );
                    }
                  }}
                >
                  <FaRegHeart
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--secondary-color)",
                      margin: "0",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {favoriteData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {favoriteData?.length}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className={classes.search_con_mobile}>
          <SearchBox
            setIsSearchBar={setIsSearchBar}
            isSearchBar={isSearchBar}
          />
        </div>
        {/* No horizontal category bar on mobile — navigation is exclusively
            through the hamburger menu (SideBar), which already lists every
            category, subcategory and sub-subcategory. */}
      </div>
      <div className={classes.navheight}></div>
      <Modal
        open={openmodal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <InfoIcon
            style={{
              color: "red",
              margin: "0 auto .5em auto",
              fontSize: "3em",
            }}
          />
          <h3 style={{ color: "red" }}>
            {language === "eng"
              ? "You cannot change the currency. Please contact the administration."
              : "Vous ne pouvez pas changer la devise. Veuillez contacter l'administration."}
          </h3>
          <div
            style={{
              width: "fit-content",
              margin: "auto",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <Button
              component={Link}
              to="/contactus"
              onClick={handleCloseModal}
              style={{
                backgroundColor: "var(--primary-color)",
                color: "white",
                height: "3em",
                width: "10em",
                borderRadius: "3em 0",
                margin: "2em auto 0 auto",
              }}
            >
              {language === "eng" ? "Contact us" : "Nous contacter"}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Navbar;
